<template>
  <div class="nav-panel flex align-center justify-between">
    <div class="flex align-center">
      <img class="logoImg" src="@/assets/login/topLogo.png" alt />
    </div>
    <div class="flex-start">
      <div class="last-login-time" v-if="JSON.stringify(accountInformation) !== '{}'">最近登录时间：{{accountInformation.customerVO.lastLoginDate }}</div>
      <div class="separator">|</div>
      <el-dropdown @command="goPersonalAccount">
        <div class="nickname-panel flex-start"  v-if="JSON.stringify(accountInformation) !== '{}'">
          <img
            v-if="accountInformation.customerVO.userAvatar"
            :src="accountInformation.customerVO.userAvatar"
            class="nav-gray-arrow"
            alt
          />
          <img class="nav-gray-arrow" v-else src="@/assets/system/userImg.png" alt />

          <div class="nickname">
            {{accountInformation.customerVO.nickName}}
            <i class="el-icon-arrow-down"></i>
          </div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1">个人账户</el-dropdown-item>
          <el-dropdown-item command="2">安全退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "headerNav",
  data() {
    return {
      accountInformation: {
        customerVO: {},
      },
    };
  },
  computed: {},
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.accountInformation = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")):{};
    },
    goPersonalAccount(command) {
      if (command == 1) {
        if (this.$route.path != "/user")
          this.$bus("checkNav", {
            path: "/user",
          });
        this.$router.push({
          path: "/user",
        });
      } else if (command == 2) {
        localStorage.setItem("userInfo", "");
        this.$router.push({
          path: "login",
        });
      }
    },
  },
  bus:{
    updateUserInfo(e){
      this.getUserInfo()
    }
  }
};
</script>

<style scoped>
.logo {
  width: 2.3rem;
  text-align: center;
}
.logoImg {
  width: 1.74rem;
  height: 0.28rem;
}

.nav-panel {
  height: 0.6rem;
  padding: 0 0.3rem 0 0.3rem;
}

.last-login-time {
  font-size: 0.12rem;
  font-weight: 400;
  color: rgba(192, 196, 204, 1);
}

.separator {
  margin: 0 0.24rem;
  color: #c0c4cc;
  font-size: 0.16rem;
}

.nickname-panel {
  cursor: pointer;
}
.nickname-panel img {
  width: 0.4rem;
  height: 0.4rem;
}
.nickname {
  font-size: 0.12rem;
  font-weight: 400;
  color: rgba(96, 98, 102, 1);
  margin-left: 0.12rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/headerNav.vue